import { useEffect, useState } from "react";
import { Dropdown, Nav, Navbar } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiAccount, mdiClipboardPulseOutline } from "@mdi/js";

import { screens } from "../../config/screens";
import { useAuth } from "../../context/AuthContext";

const locations = screens
	.filter((item) => {
		return item.showSidebar;
	})
	.map((item) => {
		return item.route;
	});

export default function Sidebar() {
	const { user, handleLogout } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	const [routeActive, setRouteActive] = useState<string>("");

	useEffect(() => {
		if (locations.includes(location.pathname)) {
			setRouteActive(location.pathname);
		}
	}, [location]);

	const handleLink = async (url: string) => {
		navigate(url);
	};

	async function handleSair() {
		handleLogout();
		navigate("/");
	}

	return (
		<Navbar
			expand="md"
			variant="dark"
			bg="dark"
			className="d-block d-md-flex flex-column d-sm-block flex-shrink-0 p-3 col-md-3 col-lg-3 col-xl-2 sticky-top shadow"
			style={{ alignItems: "unset", maxHeight: "100dvh", overflow: "auto" }}
		>
			<Navbar.Brand href="#" onClick={() => handleLink("/dashboard")} className="w-100 me-0">
				<div className="d-inline-flex justify-content-start align-items-center gap-2">
					<Icon path={mdiClipboardPulseOutline} style={{ height: 40 }} />
					<div className="d-flex flex-column align-items-center fs-3 lh-">Monitor</div>
				</div>
			</Navbar.Brand>
			<Navbar.Toggle aria-controls="basic-navbar-nav" className="float-end" />
			<Navbar.Collapse id="basic-navbar-nav" className="w-100">
				<Nav className="flex-column mb-auto w-100 h-100">
					<Nav.Item>
						<hr className="border-secondary" />
					</Nav.Item>

					{screens
						.filter((screen) => screen.showSidebar)
						.filter((screen) => !screen.superUser || (screen.superUser && user?.superUser))
						.map((screen, screenIndex) => {
							return (
								<Nav.Item key={screenIndex}>
									<Nav.Link className="d-flex" active={routeActive === screen.route} onClick={() => handleLink(screen.route)}>
										<Icon path={screen.icon} size={1} className="me-2" /> {screen.name}
									</Nav.Link>
								</Nav.Item>
							);
						})}

					<Nav.Item className="mt-auto">
						<hr className="border-secondary" />
					</Nav.Item>

					<Nav.Item>
						<Dropdown drop="up">
							<Dropdown.Toggle variant="dark" className="d-flex align-items-center w-100">
								<div className="d-flex align-items-center justify-content-center rounded-circle bg-secondary overflow-hidden me-2" style={{ width: 32, height: 32 }}>
									<Icon path={mdiAccount} size={1} color="white" />
								</div>
								{user?.nome}
							</Dropdown.Toggle>
							<Dropdown.Menu className="shadow">
								<Dropdown.Item href="#" onClick={handleSair}>
									Sair
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</Nav.Item>
				</Nav>
			</Navbar.Collapse>
		</Navbar>
	);
}
